import { ChargeConstants } from 'features/Charge/chargeHelper';
import AppRoute from 'general/constants/AppRoute';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function DashboardRoute({ ...props }) {
  // MARK: --- PROPERTIES ---
  const { user, agencyRoleList } = useSelector((state) => state.auth);
  const isAgency = user?.role === ChargeConstants.UserRole.AGENCY;
  const isMaintainer = user?.role === ChargeConstants.UserRole.MAINTAINER;
  const isFleet = user?.role === ChargeConstants.UserRole.FLEET;
  const routeName = useMemo(() => {
    if (isAgency && agencyRoleList?.length > 0) {
      return Utils.dashboardNavigation(agencyRoleList[0]);
    } else if (isMaintainer) {
      return AppRoute.maintainerDashboard;
    } else if (isFleet) {
      return AppRoute.fleetDashboard;
    }

    return AppRoute.dashboard;
  }, [user, agencyRoleList]);

  return _.isEmpty(user) ? <div>Loading...</div> : <Navigate to={routeName} />;
}

export default DashboardRoute;
